import { render } from "./AvailabilityPage.vue?vue&type=template&id=6670de18&scoped=true&ts=true"
import script from "./AvailabilityPage.ts?vue&type=script&lang=ts"
export * from "./AvailabilityPage.ts?vue&type=script&lang=ts"

import "./AvailabilityPage.vue?vue&type=style&index=0&id=6670de18&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6670de18"]])

export default __exports__